import styled from "styled-components";

const List = styled.ul`
  list-style: none;
  padding-left: 18px;
`;

export default List;
